<template>
    <section class="animated fadeInUp">
      <div class="cardHeader">
        <div class="left">
          <mark>{{ item.feeling }}</mark>
        </div>
        <div class="right" v-if="authenticated && (item.createdbyid !== authenticated && canConcur)">
          <p>
            <font-awesome-icon 
              animate="animated bounceIn" 
              icon="concierge-bell"
              @click="concurItem(item.id)">
            </font-awesome-icon>
          </p>
        </div>
        <div class="right" v-if="authenticated && (item.createdbyid !== authenticated && !canConcur)">
        <p>
          <font-awesome-icon 
            animate="animated bounceIn" 
            icon="check">
          </font-awesome-icon>
        </p>
      </div>
      </div>
      <a target="_blank" v-bind:href="item.link">
        <h2>{{ item.title }}</h2>
      </a>
      <p>{{ item.author }}</p>
      <aside>{{ item.category }}</aside>
      <div class="cardFooter">
        <div class="left">
          <p v-if="item.createdby">
            @{{ item.createdby }}
            <span>
              <vue-moments-ago prefix="shared" suffix="ago" v-bind:date="item.when" lang="en"></vue-moments-ago>
            </span>
          </p>
        </div>
        <div class="right" v-if="item.createdbyid === authenticated">
          <p>
            <font-awesome-icon
              animate="animated bounceIn"
              icon="trash-alt"
              @click="deleteItem(item.id)"
            ></font-awesome-icon>
          </p>
        </div>
      </div>
    </section>
</template>
<script>
import { db } from "@/main";
import firebase from "firebase";
import VueMomentsAgo from "vue-moments-ago";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

export default {
  components: {
    VueMomentsAgo
  },
  name: "Card",
  props: {
    msg: String,
    item: Object,
    displayName: String
  },
  data: function() {
    return {
      authenticated: firebase.auth().currentUser.uid,
      canConcur: false
    };
  },
  
  created: function() {
    if (this.authenticated) {
      db.collection("concurs")
        .where('concurs', '==', this.authenticated)
        .where('item', '==', this.item.id)
        .get()
        .then(snapshot => {
          if (snapshot) {
            this.canConcur =  snapshot.size === 0;
          }
          else
          {
            this.canConcur = false;
          }
        });
    }
  },
  methods: {
    deleteItem: function(id) {
      if (id) {
        let options = {
          okText: "yeah, remove it",
          cancelText: "nah, keep it",
          reverse: false
        };
        this.$dialog
          .confirm("Are you sure you want to remove this wisdom?", options)
          .then(function() {
            db.collection("items")
              .doc(id)
              .delete()
              .then(function() {
                console.log("Document successfully deleted");
              })
              .catch(function(error) {
                this.error = error;
              });
          })
          .catch(function() {
            console.log("Clicked on cancel");
          });
      } else {
        this.error = "Invalid ID";
      }
    },
    concurItem: function(id) {
      db.collection("items").doc(id)
        .get()
        .then(snapshot => {
          let document = snapshot.data();
            db.collection("concurs").add({
              concurs: firebase.auth().currentUser.uid, 
              concurName: this.displayName,
              item: id,
              itemTitle: document.title,
              timestamp: Date.now()
            });
            console.log("You just concurred");
        });
        this.canConcur = false;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: "Libre Franklin", sans-serif;
  font-weight: 100;
  background-color: #f2f2f2;
  color: #000;
  margin: 0;
  padding: 0;
  height: 100vh;
}

header {
  width: 75%;
  margin: 2em auto 0.5em;
}

.app-header,
.user-header {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.add-button {
  margin-left: 10px;
  margin-top: 5px;
}

.user-avatar {
  margin-right: 10px;
  /* margin-top: 5px; */
}

.font-awesome-icon {
  cursor: pointer;
}

h1 {
  /* text-transform: uppercase; */
  font-weight: 600;
  font-size: 1.75em;
  /* margin-bottom: 0.3em;
  padding-top: 1em; */
}

h2 {
  margin-top: 0.5em;
  margin-bottom: 0.125em;
  line-height: 1.1em;
}

p {
  color: rgba(0, 0, 0, 0.5);
  margin-top: 0;
  margin-bottom: 0.25em;
  font-size: 1.25em;
}

a {
  /* color: rgba(0, 0, 0, 0.5); */
  color: #000;
  text-decoration: none;
}

.logout {
  text-decoration: underline;
  cursor: pointer;
}

section {
  margin: 0 auto;
  margin-bottom: 1.25em;
  color: #30323c;
  background-color: rgba(255, 255, 255, 1);
  padding: 1em;
  width: 75%;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  padding-bottom: 0.25em;
}
mark {
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 0.75em;
  color: rgba(0, 0, 0, 1);
  padding: 4px 8px;
  border-radius: 5px;
  text-transform: uppercase;
}

aside {
  margin-bottom: 0.95em;
  text-transform: uppercase;
  font-size: 0.75em;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
}

.cardHeader {
  display: flex;
  /* font-size: 12px;
  font-weight: 400; */
  align-content: space-between;
  align-items: center;
}

.cardFooter {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  align-content: space-between;
  align-items: center;
}

.left {
  flex: 4;
}

.right p {
  width: 50px;
  cursor: pointer;
}

.right {
  color: rgba(0, 0, 0, 0.5);
  text-align: right;
  /* flex: 1; */
  margin-left: auto;
}

.vue-moments-ago {
  font-size: 1em !important;
}

.dg-content-body {
  border-bottom: 1px solid #000;
  padding-bottom: 20px;
}

.dg-content {
  text-align: center;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

.dg-content-footer {
  padding: 10px 0;
}

.dg-btn {
  width: 175px;
  margin-bottom: 0;
  font-weight: 100;
}

.dg-btn--ok {
  border-color: #000;
  color: #000;
}

.dg-btn--cancel {
  background-color: #000;
}

@media only screen and (max-width: 600px) {
  /* body {
    background-color: #fff;
  } */

  header {
    width: 90%;
    margin: 0 auto;
  }

  section {
    margin: 0 auto;
    margin-bottom: 1.25em;
    color: #30323c;
    background-color: rgba(255, 255, 255, 1);
    padding: 1em;
    width: 90%;
    border-radius: 5px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  }
}
</style>

